 // constants
import { COLOURS } from '../../constants/colours';

const getSortedGroups = (groups) => {
  const sortedGroups = [...groups].sort((a, b) => a.display.localeCompare(b.display));
  return sortedGroups;
};

const getGroupWithColor = (lastValue, lastIndex) => (group = {}) => {
  const groupValue = group?.display?.split('-')[0];
  if (groupValue !== lastValue) {
    lastIndex += 1;
    lastValue = groupValue;
  }
  return { ...group, color: COLOURS[lastIndex] };
};

 const getGroupsWithColor = (groups = []) => {
  const lastValue = '';
  const lastIndex = -1;
  const groupsWithColor = groups.map(
    getGroupWithColor(lastValue, lastIndex)
  );
  return groupsWithColor;
};

export const getSortedGroupsWithColor = (groups) => {
    const sortedGroups = getSortedGroups(groups);
    const sortedGroupsWithColor = getGroupsWithColor(sortedGroups);
    return sortedGroupsWithColor;
}
